import {PrizeItem, StatusItem} from "./status.types";

const defaultPrizes: PrizeItem[] = [
    {id: 1, name: "Коррекция воском"},
    {id: 2, name: "СПА уход за кожей головы"},
    {id: 3, name: "Детокс бороды"},
    {id: 4, name: "Черная маска"},
    {id: 5, name: "Пилинг кожи головы"},
    {id: 6, name: "Премиум уход за кожей головы"}
]

export const start = new StatusItem({
    id: 0,
    order: 0,
    code: "start",
    title: "START",
    cashback_for_visits: 20,
    discount: 0,
    prizes: [],
    need_plus: false,
    need_rank: null,
    hype_products_discount: 45,
})

export const bronze = new StatusItem({
    id: 1,
    order: 1,
    code: "bronze",
    title: "Бронза",
    cashback_for_visits: 30,
    discount: 15,
    prizes: defaultPrizes.slice(0, 1),
    need_plus: false,
    need_rank: null,
    hype_products_discount: 45,
})

const silver = new StatusItem({
    id: 2,
    order: 2,
    code: "silver",
    title: "Серебро",
    cashback_for_visits: 40,
    discount: 20,
    prizes: defaultPrizes.slice(0, 2),
    need_plus: false,
    need_rank: null,
    hype_products_discount: 45,
})

export const gold = new StatusItem({
    id: 3,
    order: 3,
    code: "gold",
    title: "Золото",
    cashback_for_visits: 50,
    discount: 25,
    prizes: defaultPrizes.slice(0, 3),
    need_plus: false,
    need_rank: null,
    hype_products_discount: 45,
})

export const platinum = new StatusItem({
    id: 4,
    order: 4,
    code: "platinum",
    title: "Платина",
    cashback_for_visits: 60,
    discount: 30,
    prizes: defaultPrizes.slice(0, 4),
    need_plus: true,
    need_rank: null,
    hype_products_discount: 50,
})

const premium = new StatusItem({
    id: 5,
    order: 5,
    code: "premium",
    title: "Премиум",
    cashback_for_visits: 70,
    discount: 35,
    prizes: defaultPrizes.slice(0, 4),
    need_plus: true,
    need_rank: null,
    hype_products_discount: 50,
})

const ultima = new StatusItem({
    id: 6,
    order: 6,
    code: "ultima",
    title: "Ультима",
    cashback_for_visits: 80,
    discount: 40,
    prizes: defaultPrizes.slice(0, 4),
    need_plus: true,
    need_rank: null,
    hype_products_discount: 50,
})

export const signature = new StatusItem({
    id: 7,
    order: 7,
    code: "signature",
    title: "Сигнейче",
    cashback_for_visits: 90,
    discount: 45,
    prizes: defaultPrizes.slice(0, 6),
    need_plus: true,
    need_rank: null,
    hype_products_discount: 50,
})

export const diamond = new StatusItem({
    id: 8,
    order: 8,
    code: "diamond",
    title: "Бриллиант",
    cashback_for_visits: 100,
    discount: 50,
    prizes: defaultPrizes.slice(0, 6),
    need_plus: true,
    need_rank: "signature",
    hype_products_discount: 55,
})

export const defaultStatuses: StatusItem[] = [
    bronze,
    silver,
    gold,
    platinum,
    premium,
    ultima,
    signature,
    diamond,
]
